module.exports = __webpack_public_path__ + "assets/img/tx101c_2.b35ba39f.jpg";